/**
 * Gen1TrunkingOrderItems テーブル用 ViewModel
 * API レスポンスのマッピング用。
 */
export default class {
    constructor(dataObject = null) {
        this.id = 0;
        this.Gen1TrunkingOrderHeaderId = 0;
        this.RepeaterQty = 0;
        this.MultiSiteNetworkingQty = 0;
        this.ExchangeRepeaterPairQty = 0;
        this.RemoveRepeaterQty = 0;
        this.isNeededUsbKeyAndSoftware = false;
        this.Grade1UnlimitedAccessUsbKeyQty = 0;
        this.Grade2LimitedAccessUsbKeyQty = 0;
        this.SystemManagerSoftwareWithGrade1KeyQty = 0;
        this.SystemManagerSoftwareQty = 0;

        if (dataObject) {
            try {
                this.id = dataObject.id ?? 0;
                this.Gen1TrunkingOrderHeaderId =
                    dataObject.Gen1TrunkingOrderHeaderId ?? 0;
                this.RepeaterQty = dataObject.RepeaterQty ?? 0;
                this.MultiSiteNetworkingQty =
                    dataObject.MultiSiteNetworkingQty ?? 0;
                this.ExchangeRepeaterPairQty =
                    dataObject.ExchangeRepeaterPairQty ?? 0;
                this.RemoveRepeaterQty = dataObject.RemoveRepeaterQty ?? 0;
                this.isNeededUsbKeyAndSoftware =
                    dataObject.isNeededUsbKeyAndSoftware ?? false;
                this.Grade1UnlimitedAccessUsbKeyQty =
                    dataObject.Grade1UnlimitedAccessUsbKeyQty ?? 0;
                this.Grade2LimitedAccessUsbKeyQty =
                    dataObject.Grade2LimitedAccessUsbKeyQty ?? 0;
                this.SystemManagerSoftwareWithGrade1KeyQty =
                    dataObject.SystemManagerSoftwareWithGrade1KeyQty ?? 0;
                this.SystemManagerSoftwareQty =
                    dataObject.SystemManagerSoftwareQty ?? 0;
            } catch (e) {
                throw new Error('Data import error @ Gen1TrunkingOrderItem.');
            }
        }
    }
}
